import PaymentReports from './payment_reports';

export default PaymentReports;